<div layout="row" class="layout-row addedit-body">
    <p>Would you like to extend the voucher expiration date by {{tollingTime}} days as well to account for the tolling tie, or days RTFA processing days?
    <br><br>
      <mat-radio-group aria-label="Select an option">
        <mat-radio-button class="addedit-padradio" (click)="selectOption('YES')" value='YES'>Yes</mat-radio-button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button class="addedit-padradio" (click)="selectOption('NO')" value='NO'>No</mat-radio-button>
      </mat-radio-group>
    </p>
  </div>